export default function AboutSection() {
  return (
    <section id="about" className="py-20 md:py-28 bg-background-500">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20">
          <div className="w-full lg:w-[50%]">
            <h2 className="text-3xl md:text-4xl font-heading font-black text-foreground-950 mb-6">
              关于五一吃瓜网
            </h2>
            <div className="space-y-4">
              <p className="text-base text-foreground-700 leading-relaxed">
                五一吃瓜网成立于2024年，是国内领先的网红黑料与网络热门事件追踪平台。我们致力于为吃瓜群众提供最及时、最全面、最可靠的热点爆料内容，覆盖娱乐圈、直播圈、短视频圈、电竞圈等多个领域。
              </p>
              <p className="text-base text-foreground-700 leading-relaxed">
                我们的编辑团队由资深娱乐记者、数据分析师和社交媒体运营专家组成，建立了行业领先的多源交叉验证机制，确保每一条爆料都有据可查。同时，我们为爆料人提供严格的隐私保护与合理的现金奖励，鼓励更多人站出来说出真相。
              </p>
              <p className="text-base text-foreground-700 leading-relaxed">
                截至目前，五一吃瓜网已累计发布超过15000条独家爆料，日均活跃用户突破10万人，已成为中文互联网最具影响力的吃瓜社区之一。
              </p>
            </div>

            <div className="mt-10 flex items-center gap-14">
              <div>
                <p className="text-4xl font-black text-foreground-950 font-heading">10W+</p>
                <p className="text-xs text-foreground-600 mt-1">日活瓜友</p>
              </div>
              <div>
                <p className="text-4xl font-black text-foreground-950 font-heading">365天</p>
                <p className="text-xs text-foreground-600 mt-1">全年无休更新</p>
              </div>
            </div>
          </div>

          <div className="w-full lg:w-[50%]">
            <div className="relative rounded-3xl overflow-hidden aspect-[4/3] bg-background-300">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20editorial%20newsroom%20with%20multiple%20screens%20displaying%20breaking%20news%2C%20dark%20aesthetic%20with%20neon%20green%20accents%2C%20professional%20team%20monitoring%20social%20media%20trends%2C%20high%20contrast%20cinematic%20photography%2C%20investigative%20journalism%20theme%2C%20dramatic%20lighting%20from%20screens&width=1000&height=750&seq=about-platform-visual&orientation=landscape"
                alt="五一吃瓜网平台介绍"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-950/70 via-transparent to-transparent"></div>

              <span className="absolute top-4 left-4 px-3 py-1 rounded-full bg-foreground-50/90 text-background-950 text-xs font-bold">
                官方平台
              </span>

              <div className="absolute bottom-4 left-4">
                <p className="text-sm font-bold text-foreground-50">五一吃瓜网</p>
                <p className="text-xs text-foreground-300 mt-0.5">官网入口持续更新</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}